import React from 'react';
import { TabContentTemplate } from 'themes/components';

function TabContent(props) {
    return <TabContentTemplate {...props} />
}

export default TabContent;